import Lottie from 'lottie-react'
import { Outlet } from 'react-router-dom'

import Header from '@/components/ui/MotorTrade/Header'
import { loaderStore } from '@/store/LoaderStore'
import animationData from '@/assets/images/cg_loading.json'

const motorTradeContainer = () => {
  const { quotesLoading } = loaderStore()

  return (
    <>
      <Header />

      {quotesLoading && (
        <div
          className="position-fixed h-100 w-100 top-0"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            zIndex: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Lottie
            animationData={animationData}
            loop
            autoplay
            style={{ height: 150, width: 150 }}
          />
        </div>
      )}
      <Outlet />
    </>
  )
}

export default motorTradeContainer
